import { Component, Vue, Prop, Watch } from "vue-property-decorator";
// import _com from "../../../assets/js/common";
import _com from "@/assets/js/common";
import jsonp from "../../../assets/js/http";
import unJsonp from "../../../assets/js/http";
import _intercept from "../../../assets/js/intercept";
import Progress from 'element-ui/lib/progress';
import 'element-ui/lib/theme-chalk/progress.css';
import cardList from "./cardList.vue";
import cookie from "@/assets/js/cookie"

Vue.component('el-progress', Progress)
const BubbleHearts = require("./flutter-hearts-zmt");

@Component({
	components: { cardList },
    computed:{

    }
})
export default class message extends Vue {
	@Prop() diff: any = 0
	@Prop() private isRecording!: any;
	@Prop() private isVideo!: any;
	@Prop() private isSection!: any;
	explainId: any = ''     // 记录讲解中商品的ID
	lineBullet: Number = 0      // 弹幕每行的行距
	browser = _com.browser();
	isShowCardTop: any = true;
	listId: any = ''   // 讲解商品的id
	timeInter: any = null;
	timeInterMsg: any = null;
	isBagInfo: Boolean = true // 是否展示讲解商品
	last_id: Number = 0;
	isTouch: boolean = false; //是否触屏
	inputFocus: boolean = false; //input是否获取焦点
	inputContent: String = ""; //发言内容
	msgData: any = []; //弹幕数据
	myMsgData: any = {}; //自己发言数据
	msgNum: any = 0; //消息已滚动数量
	unreadNum: number = 0; //未读消息
	step: any = 38; //一条消息所占高度
	msg: any = this.$refs.msg;
	msgClientHeight: any = 0; //弹幕可视高度
	activityNo: String = ""; //优惠卷code
	activityif: boolean = false;
	recommendProductShow: String = ''; //推荐商品是否显示
	isLogin: boolean = _com.getMallCookie();
	api: any = {
		getBarrage: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/barrage/static/list", //获取弹幕信息
		enterUserTime: "https://pub" + this.domain + "/ulelivebarrage/api/v1/room/user/enter", //用户进入信息
		getEnterUser: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/user/enter/list", //获取用户进入信息
		getBarrage2: "https://pub" + this.domain + "/ulelivebarrage/api/v1/barrage/list", //获取弹幕信息(不走cdn)
		getisLucky: "https://pub" + this.domain + "/ulelivebarrage/api/v1/room/luck/user/", //获取中奖状态
		getBarrageUrl: "",
		sendBarrage: "https://pub" + this.domain + "/ulelivebarrage/api/v1/barrage/submit", //发送弹幕信息
		getLike: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/room/static/like", //获取点赞数
		getCardActList: process.env.VUE_APP_URI_CDNDOMAIN + "/ulelivebarrage/api/v1/cardActivity/static/list", //获取点赞数
		submitLike: "https://pub" + this.domain + "/ulelivebarrage/api/v1/room/like/submit", //提交点赞接口 post room_name  likes
		broadcastShare: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/dwRecommond/jsonp22/2002/0/list/ule_broadcast_share.html", // 查分享文案
		// broadcastShare: "//ustatic.ulecdn.com/common-recommend-cdn/v2/recommend/dwRecommond/jsonp22/2002/0/list/ule_broadcast_share.html", // 查分享文案
		posterInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/poster/",//获取海报信息
		shareInfo: "https://pub" + process.env.VUE_APP_URI_DOMAIN + "/live/tv/share/",//获取分享信息
		ysh_text: "//ustatic" + process.env.VUE_APP_URI_ULECDNDOMAIN + "/common-recommend-cdn/v2/recommend/indexFeaturedGet/live_room_ysh_event/0/live_room_ysh_event", // 活动规则
		getYshUserInfo: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/getYshUserInfo",// 查询是否注册邮生活
		registerYsh: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/applive/ysh/registerYsh",// 快速注册邮生活
		// .testing.ulecdn.com
		uleBroadSeckill: 'https://ustatic' + process.env.VUE_APP_URI_ULECDNDOMAIN + '/common-recommend-cdn/itemRecommend/sectionList/',  // 查询code
		queryValidActivity: 'https://ustatic' + process.env.VUE_APP_URI_ULECDNDOMAIN + '/market/seckill/queryValidActivityByThemeCode/', // 查询商品
		validateLiveActivityTimes: 'https://service' + process.env.VUE_APP_URI_DOMAIN + "/seckill/activity/validateLiveActivityTimes"  // 查询资格
	};
	width = 175; //初始宽度
	height = 400; //初始高度
	heartList: any = []; //初始数组
	heartCount = 0; //累加计数初始值
	assets: any = ["/broadcast/1.png", "/broadcast/2.png", "/broadcast/3.png", "/broadcast/4.png", "/broadcast/5.png"];
	stage: any;
	posterImgUrl: any = ""//海报地址
	userEnterTime: any = ''//用户进入时间
	enterUserData: any = [] //用户进入信息
	showEnterId: any = 0//最后展示的用户id
	playIndex: number = 0 //当前播放切片视频下标 
	timeLock: Boolean = true   // 定时器开关
	setHeightCalc: any = 80
	recording: String = ''  // 是否是录播
	noSection: any = false
	isShowLuckHistory = true
	isShowCard = false
	luckHistoryTime = 0
	luckHistoryData = { prizeArr: [], isPrize: false }
	liveBroadcastStart: String = ''   // 直播开始时间
	timeDiffer: String = ''  // 距离开播时间
	timeBegin: any
	startTime: any
	currentTime: any
	differenceTime: any
	environment: any
	urlData: any = {}
	killingStatus: any = 0   // 1、登录领取 2、正在秒杀 3、即将开始 4、已售罄
	environmentUrl: any
	timeDifferShow: Boolean = false
	show: Boolean = false
	difference: number = 0;//本地时间与服务器时间差值
	liveListId: any
	isFlashStatus: Boolean = false
	codeItem: any
	sectionData: any = { itemImgUrl: '' }
	to_ule_url: any
	to_ylxd_url: any
	sectionTime: any
	isQualification: any = false
	showCountDown: any = true
	activityStartDate: any
	toSeckillLiveData: any
	countDown: any = 1000
	@Watch("diff") // 更新接收的值  ，不然只会显示第一次接收到的值
	watchDiff(newVal: number) {
		this.difference = newVal;
	}

	@Watch("isFlashStatus", { immediate: true, deep: true }) // 更新接收的值  ，不然只会显示第一次接收到的值
	watchIsFlashStatus(newVal: any) {
		if (!newVal) {
			this.sectionTime = setTimeout(() => {
				this.isFlashStatus = true
				if (this.sectionData.itemImgUrl) this.$emit('isFlash', !newVal)
			}, 10000)
		} else {
			clearTimeout(this.sectionTime)
		}
	}

	get luckHistory() {
		let history = this.$store.getters["refresh/getLuckHistory"];
		if (history.status == 2 && this.luckHistoryTime <= 1) {
			this.isShowLuckHistory = true
			this.luckHistoryTime += 1
		}
		return history;
	}
	current_cardNo: any = ''
	timerOut: any;
	get cardAct() {
		let card = this.$store.getters["refresh/getCardAct"];
		if (card.count >= 1) {
			this.isShowCard = true
			if (card.curCardActivity&&card.curCardActivity.cardActivityNo&&this.current_cardNo!=card.curCardActivity.cardInfo.cardNo) {
				this.isShowCardTop = true
				this.current_cardNo = card.curCardActivity.cardInfo.cardNo				
				console.log(card , 6666666666);
				if (_com.getMallCookie()) {
					this.$store.dispatch("refresh/getUserCardAsync", {
						cardActivityNo: card.curCardActivity.cardActivityNo,
						current: card.curCardActivity.cardInfo
					}).then(()=>{
						setTimeout(() => {
							this.$forceUpdate()
						}, 500);
						let data = this.$store.getters["refresh/getCardAllData"];
						if (data[card.curCardActivity.cardActivityNo] && 
							data[card.curCardActivity.cardActivityNo].current && 
							data[card.curCardActivity.cardActivityNo].current.totalNums>0 && 
							(!data[card.curCardActivity.cardActivityNo].combineChances[0]||(data[card.curCardActivity.cardActivityNo].combineChances[0] && data[card.curCardActivity.cardActivityNo].combineChances[0].combineFlag < 1))
						) {
							console.log('3s关闭');
							clearTimeout(this.timerOut)
							this.timerOut = setTimeout(() => {
								this.isShowCardTop = false
							}, 3000);
						} else { 
							console.log('10s关闭');
							clearTimeout(this.timerOut)
							this.timerOut = setTimeout(() => {
								this.isShowCardTop = false
							}, 30000);
						}						
					})	
				} else {
					console.log('未登录10s关闭');
					clearTimeout(this.timerOut)
					this.timerOut = setTimeout(() => {
						this.isShowCardTop = false
					}, 10000);					
				}
			}
		}
		return card;
	}
	get getPatchInfo() {
		return this.$store.getters["refresh/getPatchInfo"];
	}
	get roomData() {
		//房间数据
		let data: any = this.$store.getters["getRoomDetail/getRoomDetail"];
		if (JSON.stringify(data) != '{}' && data.tvStatus == 0) {
			let currentTime: number = new Date(data.startTime).valueOf()   // 直播时间
			let timeDifference: number = new Date().getTime() + this.difference   // 当前时间
			if ((currentTime - timeDifference) > 0 && ((currentTime - timeDifference) / 3600000) < 24) {
				this.differenceTime = setInterval(() => {
					this.timeDifferShow = true
					this.getTimeDiffer(currentTime)
				}, 16)
			} else if ((currentTime - timeDifference) > 0 && ((currentTime - timeDifference) / 3600000) > 24) {
				this.timeDifferShow = true
				this.timeDiffer = '即将开播，敬请期待！'

			} else {
				this.timeDifferShow = false
			}
		} else {
			this.timeDifferShow = false
			clearInterval(this.differenceTime)
		}
		this.$nextTick(() => {
			if (data.scene_type == 1) { // 直播状态
				this.checkHeight(0)
			} else if (data.scene_type == 2) {  // 录播状态
				this.checkHeight(50)
			}
		})
		if (data.baseTag2) {
			if (typeof data.baseTag2 === "object") {
				if (data.baseTag2.length > 0) {
					let batchIds: any = [];
					data.baseTag2.map((item: any) => {
						batchIds.push(item.batchIdCipher);
					});
					this.activityif = true;
					this.activityNo = batchIds.join(",");
				}
			} else if (typeof data.baseTag2 === "string") {
				this.activityif = true;
				this.activityNo = data.baseTag2;
			}
		}
		let isShowTag = data.tvType == 7 || data.tvType == 8
		if (isShowTag) {
			(this.domain.indexOf('beta') > -1 || this.domain.indexOf('testing') > -1) ? this.environment = 'sdycsdyc.cn' : this.environment = '100qu.net'
			if (location.href.indexOf('origin=yzlife') > -1) this.environmentUrl = 'yzlife' // 邮生活APP 邮生活公众号
			if (location.href.indexOf('origin=pmcc') > -1) this.environmentUrl = 'pmcc'   // 邮储信用卡APP
			let url = location.href
			let reg = /[?&]([^?&#]+)=([^?&#]+)/g;
			let param: any = {};
			let ret: any = reg.exec(url);
			while (ret) {//当ret为null时表示已经匹配到最后了，直接跳出
				param[ret[1]] = ret[2];
				ret = reg.exec(url);
			}
			this.urlData = param
		}
		return data;
	}
	get couponData() {
		return this.$store.getters["refresh/getCoupons"];
	}
    get isElderlyMode (){
        return this.$store.getters["environment/getElderlyMode"];
    }
	get autoCouponData() {
		return this.$store.getters["refresh/getAutoCoupons"];
	}
	get play_back_flag() {
		return this.$store.getters["refresh/getPlayBackFlag"];
	}

	get goodsMaterial() {
		return this.$store.getters["refresh/getGoodsMaterial"];
	}
	get cardAllData() {
		let data: any = this.$store.getters["refresh/getCardAllData"];
		return data;
	}	
	get luckCardAllData() {
		let data: any = this.$store.getters["refresh/getLuckCardAllData"];
		return data;
	}		
	get isCardShow() {
		return this.$store.getters["refresh/getIsCardShow"];
	}	

	get likeNum() {
		return this.$store.getters["timing/getLike"];
	}

	get isRewardClick() {
		return this.$store.getters["timing/getIsRewardClick"];
	}
	get goodsList() {
		//商品数据
		return this.$store.getters["refresh/getGoodsList"];
	}
	get recommendGoods() {
		//推荐商品
		this.toSeckillLiveData = sessionStorage.getItem('toSeckillLiveData')
		let goods = this.$store.getters["refresh/getRecommend"];
		if (JSON.stringify(goods) != "{}") {
			if (goods.isRepeat) {
				return this.animationDisplay(goods)
			} else {
				this.recommendProductShow = 'hide';
			}
		} else {
			localStorage.removeItem('recommendCommodity')
			localStorage.removeItem('explainId')
			this.explainId = ''
			this.recommendProductShow = 'hide';
		}
		this.getCode()
		return goods;
	}

	get clearScreen() {
		return this.$store.getters["environment/getClearScreen"];
	}

	get useronlyid() {
		//用户id
		return this.$store.getters["getUserOnlyId/getUserOnlyId"];
	}

	get people() {
		let total = this.$store.getters["timing/getPeople"].total;
		// 后端建议之间走pub
		// if (total > 1000) {
		// 	this.api.getBarrageUrl = this.api.getBarrage;
		// } else {
		// 	this.api.getBarrageUrl = this.api.getBarrage2;
		// }
		return total;
	}
	get roomStatus() {
		let data = this.$store.getters["getRoomDetail/getStatus"].roomStatus;
		if (data == 1) {
			this.timeDifferShow = false
			clearInterval(this.differenceTime)
		}
		return data;
	}

	get messageClose() {
		let val = this.$store.getters["environment/getMessageClose"]
		if (!val)
			this.msgScroll()
		return val;
	}
	luckyOrdering() {
		this.$http
			.jsonp(this.api.ysh_text, {
				jsonp: "jsonpCallback",
				jsonpCallback: "live_room_ysh_event",
			}).then((data: any) => {
				if (data.body.returnCode == '0000') {
					let datas = data.data.indexInfo[0]
					this.$dialog.alert({
						messageAlign: 'left',
						title: '邮生活下单礼活动规则',
						message: datas.show_text_luckyorder,
					})
					this.show = false
				}
			})
	}
	mounted() {
		let urlData = new URL(location.href)
		this.liveListId = urlData.searchParams.get('liveListId')
		// this.getCode('firstExposure')
		let height = <HTMLImageElement>document.querySelector('.msgTextCon');
		let _offsetHeight = Math.floor(height.offsetHeight / 5 - 3 - 6)
		this.lineBullet = _offsetHeight
		this.setCanvas();
		this.stage = new BubbleHearts();
		this.api.getBarrageUrl = this.api.getBarrage;
		if (this.roomStatus != 0)
			this.getBarrage(true); //获取弹幕
		this.$root.eventHub.$on('getBarrage', () => {
			this.getBarrage(false); //获取弹幕
		})
		this.getLike();
		if (_com.getMallCookie()) { // 登录
			this.getEnterUserTime();
		} else { // 未登录
			this.userEnterTime = new Date().getTime()
		}
		let timeNum = 0;
		clearInterval(this.timeInter);
		this.timeInter = setInterval(() => {
			timeNum++;
			if (this.enterUserData.length > 0) {
				if (this.enterUserData.length <= 5) {
					if (timeNum % 2 == 0) {
						this.showEnterId = this.enterUserData[0].id
						this.enterUserData.shift()
					}
				} else {
					this.showEnterId = this.enterUserData[0].id
					this.enterUserData.shift()
				}
			}
			//定时5秒获取一次弹幕
			if (timeNum % 5 == 0) {
				if (this.roomStatus != 0 && !this.messageClose)
					this.getBarrage(false);
				this.$store.dispatch("refresh/getRecommendAsync", {
					roomNumber: this.roomData.roomNumber,
					source: this.source
				});
			}
			if (timeNum % this.reshtime == 0) {
				this.getLike();
			}
			if (timeNum % 10 == 0) {
				timeNum = 0;
				this.getEnterUser()
			}
			let random = Math.floor(Math.random() * (5 - 2 + 1) + 2);
			if (timeNum % random == 0) {
				this.bubbling();
			}
		}, 1000);
		setTimeout(() => {
			if (document.querySelectorAll('.takeNotes').length) {
				let burialPoint = {
					url: location.href,
					ule_title: '直播间',
					resource_type: '直播间资源位',
					resource_name: '直播间-中奖浮标',
					remarks: this.roomData.roomNumber,
					resource_forward_url: ''
				}
				_com.sendSensorTrack('resourceExposure', this.roomData, burialPoint, true, 'yshPoint')
			}
			if (document.querySelectorAll('.postalLife').length) {
				let burialPoint = {
					url: location.href,
					ule_title: '直播间',
					resource_type: '直播间资源位',
					resource_name: '直播间-抽奖浮标',
					remarks: this.roomData.roomNumber,
					resource_forward_url: ''
				}
				_com.sendSensorTrack('resourceExposure', this.roomData, burialPoint, true, 'yshPoint')
			}
		}, 500)
	}
	getQualification() {
		let urlActivity = `${this.api.validateLiveActivityTimes}?themeCode=${this.codeItem}`
		this.$http.jsonp(urlActivity, {
			jsonp: "jsonCallBack",
			jsonpCallback: "times"
		}).then((res: any) => {
			if (res.body.code == '0014') {
				return false
			}
			const { remainingTimes, status } = res.data.data
			if (remainingTimes > 0 && status === 1) { // 有资格且总资格等于剩余次数    显示框
				this.isQualification = true
			}
		})
	}
	firstExposure = true
	async getCode() {
		try {
			let callbcak = 'uleBroadSeckill' + Math.floor(new Date().getTime() / 5000)	
			await this.$http.jsonp(this.api.uleBroadSeckill+ callbcak +'/ule_broad_seckill_code/'+Math.floor(new Date().getTime() / 5000), {
				jsonp: "jsonpCallback",
				jsonpCallback: callbcak,
			}).then((res: any) => {
				let timeDifference: any = new Date().getTime() + this.difference   // 当前时间
				// 年
				let y: any = `${new Date(timeDifference).getFullYear()}`
				// 月
				let m: any = (new Date(timeDifference).getMonth() + 1) > 9 ? `${new Date(timeDifference).getMonth() + 1}` : `0${new Date(timeDifference).getMonth() + 1}`
				// 日
				let d: any = (new Date(timeDifference).getDate()) > 9 ? `${new Date(timeDifference).getDate()}` : `0${new Date(timeDifference).getDate()}`
				let seckillCode = res.body.ule_broad_seckill_code
				let codeItem = seckillCode.findIndex((item: any) => { return item.customAttribute.seckillDate == y + m + d })

				if (!seckillCode[codeItem]) return
				this.codeItem = seckillCode[codeItem].customAttribute.seckillCode

				// .replace(/-/g,'/').getTime()
				if (seckillCode[codeItem].customAttribute.ule_url) this.to_ule_url = seckillCode[codeItem].customAttribute.ule_url
				if (seckillCode[codeItem].customAttribute.ylxd_url) this.to_ylxd_url = seckillCode[codeItem].customAttribute.ylxd_url
				this.getQualification()
				if (!this.codeItem) {
					return false
				}
				let queryValidActivity = `${this.api.queryValidActivity}${this.codeItem}/10/queryValidActivity`
				this.$http.jsonp(queryValidActivity, {
					jsonp: "jsonpCallback",
					jsonpCallback: "queryValidActivity",
				}).then((res: any) => {
					let currentField = res.body.seckillActitityDto.currentField
					let activityDto: any = currentField.activityDto
					let sectionStatus = 0
					this.activityStartDate = activityDto.startDate.split(' ')[1].slice(0, 5)
					if (new Date().valueOf() < new Date(activityDto.startDate.replace(/-/g, '/')).valueOf()) {  // 即将开始
						sectionStatus = 3
						this.setCountDown(activityDto.startDate)
					} else if (new Date(activityDto.startDate.replace(/-/g, '/')).valueOf() < new Date().valueOf() && new Date().valueOf() < new Date(activityDto.sellTime.replace(/-/g, '/')).valueOf()) {  // 秒杀中
						sectionStatus = 2
						// this.setCountDown(activityDto.endDate)
					}
					let sectionList = currentField.itemList
					let soldList: any = [] // 已售罄
					let forSaleList: any = [] // 在售
					sectionList.forEach((item: any) => {  // 有在售商品
						item.selloutFlag ? soldList.push(item) : forSaleList.push(item)
					})
					if (forSaleList.length > 0) { // 有在售商品
						let subscript = Math.floor(Math.random() * forSaleList.length)
						this.sectionData = forSaleList[subscript]
					} else { // 没有在售商品
						let subscript = Math.floor(Math.random() * soldList.length)
						this.sectionData = soldList[subscript]
						sectionStatus = 4
					}
					if (this.firstExposure) {
						this.firstExposure = false
						let sectionData = this.sectionData
						setTimeout(() => {
							let tvType = this.roomData.tv_type == 7 || this.roomData.tv_type == 8
							let data: any;
							if (sectionStatus == 2 || sectionStatus == 3) {
								data = {
									$url: location.href,
									ule_title: '邮乐直播2',
									resource_type: '直播间-秒杀贴片',
									resource_content: sectionData.itemName,
									resource_item_type: tvType ? '活动' : '商品',
									resource_item_id: '',
									// resource_item_id: sectionData.listId,
									resource_forward_url: tvType ? this.jumpUrl() : this.patchInfo(this.sectionData),
									ul_aid: 'LIVE_秒杀贴片'
								}
							}
							if (sectionStatus == 4) {
								data.resource_item_type = '活动'
								data.resource_item_id = activityDto.id
							}
							this.buryingFn(data, 'resourceExposure')
						}, 1000)
					}
					// let sectionNum = sectionList.map((item: any) => { return item.selloutFlag == true })
					// if (sectionNum.length < 1) sectionStatus = 4
					if (sectionStatus == 0) this.sectionData = null
					this.killingStatus = sectionStatus
					if (!_com.getMallCookie()) { // 未登录
						this.killingStatus = 1
						return false
					}
				})
			})
		} catch (error) { }
	}
	buryingFn(buryingData: any, name: any) { // 曝光和点击秒杀活动埋点
		_com.sendSensorTrack(name, this.roomData, buryingData, true, 'yshPoint')
	}
	setCountDown(data: any) {
		let end_time: any = (new Date(data.replace(/-/g, '/')))
		let timeDValue = Date.parse(end_time) - new Date().getTime()
		this.countDown = timeDValue
	}
	countDownEnd() {
		this.showCountDown = !this.showCountDown
		this.getCode()
	}
	format(percentage: any) {
		console.log(percentage, 'percentage')
		return `10 s`
	}
	flashStatus() {
		this.isFlashStatus = !this.isFlashStatus
		if (this.sectionData.itemImgUrl) this.$emit('isFlash', this.isFlashStatus)
	}
	jumpUrl() {
		if (this.browser.ylxd) {
			return this.to_ylxd_url ? this.to_ylxd_url : 'https://www.ule.com/event/h5/ule/5787.html'
		} else {
			let to_ule_url;
			if (process.env.VUE_APP_URI_DOMAIN.indexOf('beta') >= 0) {
				to_ule_url = 'https://www.beta.ule.com/event/h5/ule/628.html'
			} else if (process.env.VUE_APP_URI_DOMAIN.indexOf('testing') >= 0) {
				to_ule_url = 'https://www.testing.ule.com/event/h5/ule/1464.html'
			} else {
				to_ule_url = 'https://www.ule.com/event/h5/ule/5727.html'
			}
			return this.to_ule_url ? this.to_ule_url : to_ule_url
		}

	}
	goSection() {
		if (this.killingStatus == 1 && !_intercept()) {
			return false;
		}
		let data = {
			ule_title: '邮乐直播',
			resource_type: '直播间-秒杀贴片',
			resource_content: this.sectionData.itemName,
			resource_item_type: '',
			resource_item_id: this.sectionData.listId,
			resource_forward_url: '',
			ul_aid: 'LIVE_秒杀贴片'
		}
		if (!this.browser.ylxdsq && !this.browser.usqxcx && (this.killingStatus == 3 || this.killingStatus == 4 || this.roomData.tv_type == 7 || this.roomData.tv_type == 8)) {
			data.resource_item_type = '活动'
			data.resource_forward_url = this.jumpUrl()
			this.buryingFn(data, 'resourceClick')
			location.href = this.jumpUrl()
		} else {
			data.resource_item_type = '商品'
			data.resource_forward_url = this.patchInfo(this.sectionData)
			this.buryingFn(data, 'resourceClick')
			location.href = this.patchInfo(this.sectionData)
		}
	}
	goPatchInfo(data: any) {
		location.href = this.patchInfo(data)
	}
	patchInfo(data: any) {
		let getPatchInfo: any = {};
		let room = this.roomData
		let type = '直播'
		if (room.scene_type == 2) {
			type = '录播'
		}
		let unionParams = `union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&live_id=${room.id}&live_name=${room.title}&live_type=${type}&ul_aid=LIVE_秒杀贴片`
		if (getPatchInfo.list_name) {
			_com.sendSensorTrack('ItemClick', room, {
				module_sort: 1,
				listId: getPatchInfo.list_id,
				listName: getPatchInfo.list_name,
				minPrice: getPatchInfo.minPrice
			})
		}
		if (data != 'Patch') { // 当前展开的是秒杀
			if (this.$route.query.ylxdFlag) unionParams += '&ylxdFlag=1'
			if (data['list_id']) {
				getPatchInfo['list_id'] = data.listId
			}
			//直播秒杀商品跳转到直播秒杀页面
			if (this.$route.query.storeid && this.$route.query.shareId) {
				unionParams += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&client_type=app_ylxd`
			} else if (this.browser.usqxcx) {
				unionParams += '&client_type=miniwx_ulemall'
			}
			return `//h5${this.domain}/item/seckill_live/${data.listId}.html?${unionParams}&t=${new Date().getTime()}`
		} else {	// 贴片
			getPatchInfo = this.getPatchInfo
			if (this.getPatchInfo.open_url) return getPatchInfo.open_url

			if (this.roomData.tvType == 7) { // 主题卡直播
				return 'https://ycst.' + this.environment + '/fenqiztk/#/detail/' + getPatchInfo.good_id + '/' + getPatchInfo.list_id + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act']
			} else if (this.roomData.tvType == 8) { // 分期直播
				return 'https://ycst.' + this.environment + '/fenqi/#/detail/' + getPatchInfo.good_id + '/' + getPatchInfo.list_id + '?bqkey=fq&origin=' + this.environmentUrl + '&act=' + this.urlData['act']
			}
			let unionParams = `union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&live_id=${room.id}&live_name=${room.title}&live_type=${type}`
			if (this.browser.uxdxcx) {
				(<any>window).wx.miniProgram.navigateTo({ url: `/pages/detail/detail?listingId=${getPatchInfo.list_id}&${unionParams}` })
			}
			if (this.source == "ule") {
				// 邮乐商城
				if (this.browser.ule) {
					try {
						let adid = this.$route.query.adid || '';
						(window as any).dsBridge.call("generalAction", {
							type: "3",
							ios_action: `UleProductDetailViewController::0&&listId::${getPatchInfo.list_id}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
							android_action: `ProductActivity&&wgt.PrdDetail&&listId::${getPatchInfo.list_id}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
							router_action:`prd&&listId::${getPatchInfo.list_id}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##fromH5Vi::true`
						})
					} catch (error) {
						return "uleMobile://uleVi_" + getPatchInfo.list_id;
					}
				} else {
					return `//item${this.domain}/mitem/item/view/${getPatchInfo.list_id}?${unionParams}`;
				}
			} else if (this.source == "uxd") {
				// 邮乐小店
				if (this.browser.wxwork) {
					return `//h5${this.domain}/yxd/mall/item/app/${getPatchInfo.list_id}?isBuy=false&storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				} else if (this.browser.ylxd || this.browser.yzg || this.browser.zyet) {
					return `//h5${this.domain}/yxd/mall/item/app/${getPatchInfo.list_id}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				} else if (this.$route.query.storeid && this.$route.query.shareId) {
					return `//h5${this.domain}/yxd/mall/item/web/${getPatchInfo.list_id}?storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&imageType=xl&client_type=app_ylxd&adid=ylxdfx_merchant&preview=1&${unionParams}`;
				} else {
					return `//item${this.domain}/mitem/item/view/${getPatchInfo.list_id}?${unionParams}`;
				}
			} else if (this.source == "usq") {
				// 邮乐优鲜
				if (this.$route.query.storeid && this.$route.query.shareId) {
					return "//h5" +
						this.domain +
						"/yxd/community/item/itemPage/" +
						getPatchInfo.list_id +
						"?union_id=1016039300&union_ref=" +
						this.$route.params.roomNumber + '_' + room.scene_number +
						"&storeid=" +
						this.$route.query.storeid +
						"&shareId=" +
						this.$route.query.shareId;
				} else {
					return "//h5" + this.domain + "/yxd/community/item/itemPage/" + getPatchInfo.list_id + "?union_id=1016039300&union_ref=" + this.$route.params.roomNumber + '_' + room.scene_number;
				}
			} else if (this.source == "uzg") {
				return "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/GoodsDetails/" + getPatchInfo.list_id + '?scene_id=' + room.scene_id + '&roomNumber=' + room.roomNumber + '&scene_number=' + room.scene_number;
			} else if (this.source == "ysh") { // 邮生活直播
				let pointSuppilersId = (this.domain.indexOf('beta') >= 0 || this.domain.indexOf('testing') >= 0) ? 3607 : 3031
				let from = '' // 微信
				if (this.$route.query.from == 'yshmp') from = 'yshmp' // 邮生活小程序
				if (this.browser.yshapp) {
					from = 'yshapp' // 邮生活app
					let srcid = 'live_app_hd_yshhy'
					let domainName = 'yshUnionLogin'
					let dataApp = {
						"closeCurrentPage": "0",
						"realName": "0",
						"appid": this.domain == '.beta.ule.com' ? '0f6258b721d04abc96c893cf84740fb2' : '8c8d70950ed04e1a9516559d35b784fc',
						"targetUrl": `https://m${this.domain}/mthirdparty/tp/${domainName}?redirectUrl=${encodeURIComponent(window.location.href)}`
					};
					// closeCurrentPage  当前h5页面是否关闭 0=不关闭；1=关闭
					// realName  是否需要实名校验 0=不需要；1=需要
					// targetUrl 联合登陆后跳转地址
					(<any>window).Emp.execute("callApp('thirdH5_goToJointLogin','goToJointLogin','" + JSON.stringify(dataApp) + "')");
				}
				return `https://item${this.domain}/pointitem/ysh/${getPatchInfo.list_id}-0-1.html?pointSupplierId=${pointSuppilersId}&from=${from}&operationSource=6&union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&adid=ylxdfx_merchant`
			}

		}
	}
	getTimeDiffer(currentTime: number) { // 计算距离开播相差多久 currentTime:开播时间
		let startTime = new Date().valueOf()
		let runTime = (currentTime - startTime) / 1000;
		runTime = runTime % (86400 * 365);
		runTime = runTime % (86400 * 30);
		runTime = runTime % 86400;
		let hour = Math.floor(runTime / 3600);
		runTime = runTime % 3600;
		let minute = Math.floor(runTime / 60);
		runTime = runTime % 60;
		let second = Math.floor(runTime);
		if (second < 0) {
			this.timeDifferShow = false
			// this.timeDiffer = `00 : 00 : 00`
			clearInterval(this.differenceTime)
			return
		}
		this.timeDiffer = `${hour < 10 ? '0' + hour : hour} : ${minute < 10 ? '0' + minute : minute} : ${second < 10 ? '0' + second : second} 后开播`
	}
	getisLucky() {//获取中奖历史
		console.log('点击');
		if (this.luckHistory.status == 2) {//正在抽奖
			this.$toast("正在开奖中...");
			return false
		}
		const callback = 'luck'
		let url = `${this.api.getisLucky}${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonp: callback,
			jsonpcallback: callback
		}).then(
			(data: any) => {
				// this.luckHistoryData.isPrize = false
				if (data.lucks) {
					const isPrize = data.lucks.filter((item: any) => { return item.flag == 1 })
					this.luckHistoryData.isPrize = isPrize.length > 0
				}
				// data.lucks.forEach((item: any) => {
				// 	if (item.flag == 1) {
				// 		this.luckHistoryData.isPrize = true
				// 	}
				// });
				this.luckHistoryData.prizeArr = data.lucks;
				this.$store.dispatch('refresh/setIsShowPrizeHistoryAsync', true);
			}, (err: any) => {
				console.log(err);
			}
		)
	}
	closeLuckHistory() {
		this.isShowLuckHistory = !this.isShowLuckHistory
	}
	animationDisplay(data: any) {  // 动画左移右移处理
		let localRecommend: any = localStorage.getItem('recommendCommodity')  // 动画效果处理
		let explainId: any = localStorage.getItem('explainId')	// 15秒自动关闭处理
		if (!localRecommend) {
			this.recommendProductShow = 'left';
			localStorage.setItem('recommendCommodity', JSON.stringify(data))
			let time: any = sessionStorage.getItem('toSeckillLiveData')
			this.claerGoods(data.listId, time == 1 ? 30000 : 15000)
			return data
		} else {
			if (!explainId) {
				if (JSON.parse(explainId) == data.listId) {
					this.explainId = 'hide';
					return data
				}
			} else {
				let time: any = sessionStorage.getItem('toSeckillLiveData')
				this.claerGoods(data.listId, time == 1 ? 30000 : 15000)
			}
			if (JSON.parse(localRecommend).listId != data.listId) {
				this.recommendProductShow = 'right';
				localStorage.setItem('recommendCommodity', JSON.stringify(data))
				return JSON.parse(localRecommend)
			} else {
				this.recommendProductShow = 'left';
				localStorage.setItem('recommendCommodity', JSON.stringify(data))
				return data
			}
		}
	}
	claerGoods(data: any, time: any) { // 动画关闭定时器
		if (this.timeLock) {
			this.timeLock = false
			let burialPoint = {
				item_name: this.recommendGoods.listName,
				item_explain_status: '讲解中',
				commodity_original_price: this.recommendGoods.priceRange,
				commodity_current_price: this.recommendGoods.minPrice,
				current_page_name: '直播间',
				page_area: '讲解中商品气泡',
				category3: this.recommendGoods.categoryName
			}

			_com.sendSensorTrack('itemShow', this.roomData, burialPoint, true, 'yshPoint')
			setTimeout(() => {
				localStorage.setItem('explainId', data)  // 记录当前讲解商品ID
				this.timeLock = true
				this.explainId = data
				this.$forceUpdate()
			}, time)
		}
	}
	checkHeight(data: number = 90) {
		let height = <HTMLImageElement>document.querySelector('.msgTextCon');
		let heightCalc = <HTMLImageElement>document.querySelector('.goodBag');
		let setHeightCalc = heightCalc.offsetHeight - height.offsetHeight    // 计算直播和带切片的录播时，进度条和弹幕的高度
		this.setHeightCalc = setHeightCalc + data
	}
	bagInfoFn() {
		localStorage.setItem('explainId', this.recommendGoods.listId)  // 记录当前讲解商品ID
		this.explainId = this.recommendGoods.listId
	}
	setCanvas() {
		this.assets.forEach((src: string, index: number) => {
			this.assets[index] = new Promise(function (resolve) {
				let img = new Image();
				let num = Math.floor(Math.random() * (20 - 30 + 1) + 30);
				img.width = num * window.devicePixelRatio;
				img.height = num * window.devicePixelRatio;
				img.onload = resolve.bind(null, img);
				img.src = src;
			});
		});
	}
	//切换录播播放地址 / 跳转商品详情
	changePlay(goods: any, index: number) {
		if (this.playIndex == index) {
			//去详情
			if (goods.listingState == 2 || goods.storage <= 0) {
				//已下架   无库存
				return false;
			}
			(<any>event).stopPropagation();
			if (goods.isSale == 0) {//不可售区域点击不跳转
				return false;
			}
			let room = this.roomData
			console.log(room);
			let type = '直播'
			if (room.scene_type == 2) {
				type = '录播'
			}
			let unionParams = `union_id=1016039300&union_ref=${this.$route.params.roomNumber}_${room.scene_number}&live_id=${room.id}&live_name=${room.title}&live_type=${type}`
			if (this.$route.query.ul_aid) {
				unionParams += `&ul_aid=${this.$route.query.ul_aid}`
			}
			if (goods.activityType == '1') {
				if (this.$route.query.ylxdFlag) unionParams += '&ylxdFlag=1'
				//直播秒杀商品跳转到直播秒杀页面
				if (this.$route.query.storeid && this.$route.query.shareId) {
					unionParams += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&client_type=app_ylxd`
				} else if (this.browser.usqxcx) {
					unionParams += '&client_type=miniwx_ulemall'
				}
				location.href = `//h5${this.domain}/item/seckill_live/${goods.listId}.html?${unionParams}&t=${new Date().getTime()}`;
				return false;
			}
			if (goods.activityType == '2') {//优鲜接龙  跳转接龙详情页面
				location.href = `//h5${this.domain}/yxd/community/chains/chainsDetail/${goods.activityCode}?${unionParams}`;
				return false;
			}
			if (goods.link) {//跳转中转页
				sessionStorage.setItem("from", "true");

				let params;
				if (this.$route.query.storeid)
					params = '?storeid=' + this.$route.query.storeid;
				this.$router.push({
					path: goods.link + '/' + goods.listId + '/' + this.source + params
				});
				return false;
			}
			if (this.browser.ulexcx && this.browser.ulexcx > 2000) {//新版邮乐商城小程序
				(<any>window).wx.miniProgram.navigateTo({ url: `/packageA/item/item?listId=${goods.listId}&${unionParams}` })
			} else if (this.browser.uxdxcx) {
				(<any>window).wx.miniProgram.navigateTo({ url: `/pages/detail/detail?listingId=${goods.listId}&${unionParams}` })
			}
			else if (this.source == "ule") {
				// 邮乐商城
				if (this.browser.ule) {
					try {
						let adid = this.$route.query.adid || '';
						(window as any).dsBridge.call("generalAction", {
							type: "3",
							ios_action: `UleProductDetailViewController::0&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
							android_action: `ProductActivity&&wgt.PrdDetail&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##h5_orderSourceId::`,
							router_action:`prd&&listId::${goods.listId}##h5_unionId::1016039300##h5_unionRef::${this.$route.params.roomNumber}_${room.scene_number}##h5_adid::${adid}##fromH5Vi::true`
						})
					} catch (error) {
						location.href = "uleMobile://uleVi_" + goods.listId;
					}
				} else {
					location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}`;
				}
			} else if (this.source == "uxd") {
				// 邮乐小店
				if (this.browser.wxwork) {
					location.href = `//h5${this.domain}/yxd/mall/item/app/${goods.listId}?isBuy=false&storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				} else if (this.browser.ylxd || this.browser.ylxdsq || this.browser.yzg || this.browser.zyet) {
					location.href =
						`//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				} else if (this.browser.weixin && (cookie.get('sub_sch') == 'jinfuxiaodian')) {
					location.href =
						`//h5${this.domain}/yxd/mall/item/app/${goods.listId}?storeid=${this.useronlyid}&imageType=xl&client_type=app_ylxd&preview=1&${unionParams}`;
				} else if (this.$route.query.storeid && this.$route.query.shareId) {
					location.href =
						`//h5${this.domain}/yxd/mall/item/web/${goods.listId}?storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}&imageType=xl&client_type=app_ylxd&adid=ylxdfx_merchant&preview=1&${unionParams}`;
				} else if (this.browser.usqxcx) {//优鲜小程序内跳转大网详情页时带上client_type=miniwx_ulemall  详情页重写cookie  
					location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?client_type=miniwx_ulemall&${unionParams}`;
				} else {
					location.href = `//item${this.domain}/mitem/item/view/${goods.listId}?${unionParams}`;
				}
			} else if (this.source == "usq") {
				// 邮乐优鲜
				if (this.$route.query.storeid && this.$route.query.shareId) {
					location.href =
						"//h5" +
						this.domain +
						"/yxd/community/item/itemPage/" +
						goods.listId +
						"?union_id=1016039300&union_ref=" +
						this.$route.params.roomNumber + '_' + room.scene_number +
						"&storeid=" +
						this.$route.query.storeid +
						"&shareId=" +
						this.$route.query.shareId;
				} else {
					location.href = "//h5" + this.domain + "/yxd/community/item/itemPage/" + goods.listId + "?union_id=1016039300&union_ref=" + this.$route.params.roomNumber + '_' + room.scene_number;
				}
			} else if (this.source == "uzg") {
				location.href = "//www" + this.domain + "/app/yzg/wholesale_h5/index.html#/GoodsDetails/" + goods.listId + '?scene_id=' + room.scene_id + '&roomNumber=' + room.roomNumber + '&scene_number=' + room.scene_number;
			}
			// 点击埋点
			_com.sendSensorTrack('ItemClick', room, {
				module_sort: index,
				listId: goods.listId,
				listName: goods.listName,
				minPrice: goods.minPrice
			})
		} else {
			this.playIndex = index
			this.$emit("changePlay", { isBackChange: false, hlsURL: goods.linkUrl })
		}
	}
	//切换录播播放地址 切片与主视频切换
	changeVideo(good: any) {
		if (this.isSection) {//正在播放切片视频  切回完整回放
			this.playIndex = 0
			this.setHeightCalc = ''
			this.$emit("changePlay", { isBackChange: true, hlsURL: this.roomData.hlsURL })
		} else {
			this.checkHeight(70)
			this.$emit("changePlay", { isBackChange: false, hlsURL: this.goodsMaterial[this.playIndex].linkUrl })
		}
	}
	hideRP() {
		//隐藏推荐商品
		// this.recommendProductShow = true;
		// setTimeout(() => { //推荐商品五秒后自动隐藏
		//     this.recommendProductShow = false;
		// }, 5000);
	}
	getEnterUser() {
		//获取进入直播间用户
		let callback = "enter";
		let url = `${this.api.getEnterUser}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 10000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonpcallback: callback,
		}).then((res: any) => {
			let num = -1, arr = [];
			for (let i = 0; i < res.length; i++) {
				if (res[i].id > this.showEnterId && res[i].time > this.userEnterTime) {
					num = i;
					break;
				}
			}
			if (num > -1) {
				arr = res.slice(num)
				this.enterUserData = this.enterUserData.concat(arr)
			}
		}, (error: any) => {
		});
	}
	getEnterUserTime() {
		//获取进入直播间用户
		let callback = "enterTime";
		let url = `${this.api.enterUserTime}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 10000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonpcallback: callback,
		}).then((res: any) => {
			this.userEnterTime = res.time
			this.getEnterUser()
		}).catch(res => { })
	}
	getBarrage(val: any) {
		//获取直播间弹幕
		let callback = "barrage";
		let url = `${this.api.getBarrageUrl}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();
		jsonp(url, {
			jsonpcallback: callback,
			last_id: this.last_id,
		}).then((res: any) => {
			if (val) {
				this.msg = this.$refs.msg;
				this.msgClientHeight = this.msg.clientHeight;
			}
			if (res.datas && res.datas.length > 0 && res.datas[res.datas.length - 1].id > this.last_id) {
				for (let i = 0, len = res.datas.length; i < len; i++) {
					const msg = res.datas[0];
					if (this.last_id >= msg.id) {
						res.datas.shift();
					}
				}
				if (res.datas.length > 0) {
					this.last_id = res.datas[res.datas.length - 1].id;
					this.msgData = this.msgData.concat(res.datas);
					if (this.msgData.length > 100) {
						this.msgData.splice(0, (this.msgData.length - 100));
					}

					if (this.isTouch) {
						this.unreadNum = this.msgData.length - this.msgNum;
					} else {
						this.unreadNum = 0;
					}
					this.$nextTick(() => {
						this.step = this.msg.children[0].children[0] ? this.msg.children[0].children[0].offsetHeight + 10 : 38;
						this.msgScroll();
						if (val) {
							this.msg.scrollTo(0, this.msg.scrollHeight);
							this.msgNum = Math.ceil((this.msg.scrollHeight - this.msgClientHeight) / this.step);
						}
					});
				}
			}
		});
	}
	sendBarrage() {
		if (!_intercept()) {
			return false;
		}
		if (this.roomStatus == 0) {
			this.$toast("直播还未开始喲，发言暂时不会展示在直播间呢");
			return false;
		}
		//发送直播间弹幕
		let num = Math.ceil(this.msgClientHeight / this.step);
		this.fetch({
			url: this.api.sendBarrage,
			data: {
				room_name: this.$route.params.roomNumber,
				content: this.inputContent,
			},
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
		}).then(
			(data: any) => {
				let index = 0;
				let lastIdx = 0;
				this.msgData.map((msg: any, idx: number) => {
					if (msg.nickName == data.nickName) {
						lastIdx = idx + 1;
					}
				})
				if (this.msgNum + num >= this.msgData.length) {
					index = this.msgData.length;
				} else {
					index = this.msgNum + num;
					if (index < lastIdx) {
						index = lastIdx;
					}
				}
				this.msgData.splice(index, 0, {
					content: this.inputContent,
					id: data.id,
					nickName: data.nickName,
				});
				this.myMsgData[data.id] = this.inputContent;
				this.inputContent = "";
				this.$nextTick(() => {
					this.msgScroll();
				});
			},
			(data: any) => {
				let txt = '';
				if (data.code == 10000) this.clearStorage('用户信息过期')
				switch (data.code) {
					case "30000":
						txt = "检测到您的发言有敏感词，请重新输入";
						break;
					case "10000":
						txt = "用户信息过期";
						break;
					case "10001":
						txt = "你已被主播禁言。被禁言的用户不能发送发言";
						break;
				}

				if (txt != "") {
					this.$toast({
						message: txt,
						className: "topIndex",
						position: "bottom",
						duration: 2000,
					});
				}

			}
		);
		let liveName = ''
		if (this.roomData.tvStatus == 0) liveName = '待开播'
		if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
		if (this.roomData.tvStatus == 2) liveName = '已结束'

		let ylw_BulletChatSend = {
			// ylw_live_id: this.roomData.id,
			// ylw_live_name: this.roomData.title,
			// ylw_live_type: liveName,
			ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
			ylw_live_id: this.roomData.id,
			ylw_live_name: this.roomData.title,
			ylw_live_type: liveName,
			roomNumber: this.roomData.roomNumber,
			scene_number: this.roomData.scene_number,
			theme: this.roomData.theme,
			ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid')
		}

		// _com.sendSensorTrack('发送弹幕', {}, ylw_BulletChatSend, false, 'yshPoint')

		// 发言埋点
		_com.sendSensorTrack('BulletChatSend', this.roomData, ylw_BulletChatSend, false, 'yshPoint')
	}
	focus() {
		setTimeout(() => {
			this.inputFocus = true;
		}, 400);
	}

	blur() {
		if (_com.isIos()) {
			setTimeout(() => {
				var scrollHeight = document.body.clientHeight || 0;
				window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			}, 100);
		}
		this.inputFocus = false;
	}
	msgScroll() {
		if (this.isTouch || this.msgData.length < Math.floor(this.msgClientHeight / this.step)) {
			return false;
		}
		clearInterval(this.timeInterMsg);
		let timer: any = null;
		this.timeInterMsg = setInterval(() => {
			//0.5秒滚动一次弹幕
			clearInterval(timer);
			let time = 0;

			timer = setInterval(() => {
				time++;
				if (time > this.step) {
					clearInterval(timer);
				} else {
					this.msg.scrollTo(0, this.msg.scrollTop + 1);
					// if(this.msgData.length>100){
					// 	this.msgData.splice(0,1);
					// }
				}
			}, 16);
			if (this.msg.scrollTop + this.msgClientHeight < this.msg.scrollHeight) {
				this.msgNum++;
			} else {
				clearInterval(this.timeInterMsg);
			}
		}, 500);
	}
	scrollBottom() {
		//弹幕滚动到底
		this.msg.scrollTo(0, this.msg.scrollHeight);
		this.unreadNum = 0;
		this.isTouch = false;
	}


	agreeOn() { // 协议跳转
		window.location.href = 'https://www.ule.com/event/h5/ule/26.html'
	}
	conceal() { // 隐私跳转
		window.location.href = 'https://www.ule.com/event/h5/ule/27.html'
	}
	clearStorage(msg?: any) {
		localStorage.clear();
		sessionStorage.clear();
		var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
		if (keys) {
			for (var i = keys.length; i--;) {
				document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();
				document.cookie = keys[i] + '=0;path=/;domain=' + this.domain + ';expires=' + new Date(0).toUTCString();
			}
		}
		this.$toast({
			message: msg ? msg : "您的账号未绑定手机号，请前往“个人中心/个人资料”中进行绑定！",
			duration: 2000,
			onClose: function () {
				if (!_intercept()) {
					return false;
				}
			}
		})
	}
	ImmediateLottery() { // 参与下单邮礼活动
		let serviceAgreementId = this.domain == '.ule.com' ? 12 : 20
		let url = `${this.api.registerYsh}?serviceAgreementId=${serviceAgreementId}`
		jsonp(url, {
			jsonp: 'jsonCallback',
			clientCallType: 'h5'
		}).then((res: any) => {
			this.show = false
			this.$toast('活动参与成功~')
		}).catch(res => {
			if (res.returnCode == 76040) this.clearStorage()
			this.$toast(res.returnMessage)
		})
	}
	skip() {
		this.show = false
		this.expandGoods()
		sessionStorage.setItem('orderBox', 'orderBox')
	}
	showGoodsList() {
		if (!_intercept()) {
			return false;
		}

		let style: any = document.querySelectorAll('.allIcons')[0]
		style.style.display = 'none'
		let liveName = ''

		if (this.roomData.tvStatus == 0) liveName = '待开播'
		if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
		if (this.roomData.tvStatus == 2) liveName = '已结束'
		let ylw_LiveCartClick = {
			// ylw_live_id: this.roomData.id,
			// ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
			// ylw_live_name: this.roomData.title,
			// ylw_live_type: liveName,
			ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
			ylw_live_id: this.roomData.id,
			ylw_live_name: this.roomData.title,
			ylw_live_type: liveName,
			roomNumber: this.roomData.roomNumber,
			scene_number: this.roomData.scene_number,
			theme: this.roomData.theme,
			ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid')
		}
		_com.sendSensorTrack('LiveCartClick', this.roomData, ylw_LiveCartClick, false, 'yshPoint')

		if (this.explainId != this.recommendGoods.listId && !this.isSection) {
			let burialPoint = {
				// item_name: this.recommendGoods.listName,
				item_explain_status: '讲解中',
				commodity_original_price: this.recommendGoods.priceRange,
				commodity_current_price: this.recommendGoods.minPrice,
				current_page_name: '直播间',
				page_area: '讲解中商品气泡',
				scene_number: this.roomData.scene_number,
				roomNumber: this.$route.params.roomNumber,
				item_id: this.recommendGoods.listId,
				category3: this.recommendGoods.categoryName
			}

			_com.sendSensorTrack('itemClick', {}, burialPoint)
		} else {
			let btnClick = {
				url: location.href,
				ule_title: '直播间',
				button_name: '直播间-商品口袋',
				// remarks: this.$route.params.roomNumber,
				scene_number: this.roomData.scene_number,
				roomNumber: this.$route.params.roomNumber,
				link_url: '',
			}

			_com.sendSensorTrack('btnClick', {}, btnClick)
		}

		if (this.roomData.orderCourtesy == 1) { // 1 开启了下单邮礼
			let url = `${this.api.getYshUserInfo}`
			jsonp(url, {
				jsonp: 'jsonCallback',
				clientCallType: 'h5'
			}).then((res: any) => {
				if (res.userId) {
					this.expandGoods()
				}
			}).catch((res) => {
				if (res.returnCode == 76040) this.clearStorage()
				// this.$toast(res.returnMessage)
				sessionStorage.getItem('orderBox') == 'orderBox' ? this.expandGoods() : this.show = true
			})
		} else {
			this.expandGoods()
		}
	}
	expandGoods() {
		//展开商品列表
		this.$store.dispatch("environment/getIsGoodsListAsync", true);
		this.$store.dispatch("environment/getIfBatchTitleAsync", false);
		// 点击购物车图标埋点
		_com.sendSensorTrack('LiveCartClick', this.roomData, {})
	}
	touch(isTrue: boolean) {
		//触屏事件
		this.isTouch = isTrue;
		if (isTrue) {
			clearInterval(this.timeInterMsg);
		} else {
			this.unreadNum = 0;
			this.msgScroll();
			this.msgNum = Math.ceil((this.msg.scrollHeight - this.msgClientHeight) / this.step);
		}
	}
	more() {
		this.$store.dispatch('environment/getIsShowOperatAsync', true);
	}
	//获取海报地址
	getPosterUrl() {
		if (!_intercept()) {
			return false;
		}
		let typeObj: any = {
			'uxd': '5',
			'ule': '4',
			'usq': '3',
			'uzg': '1'
		};
		let callback = "posterInfo";
		let url = this.api.posterInfo + this.$route.params.id + "?tv_type=" + typeObj[this.source]
		jsonp(url, {
			jsonpcallback: callback,
			jsonp: 'callback',
		}).then((data: any) => {
			console.log('这里是新的海报地址', data);
			this.posterImgUrl = data || "";
			this.getShare();
		}).catch((err: any) => {
			this.getShare();
		});
	}
	getShare() {
		// _intercept();
		//分享
		let shareUrl = location.origin + location.pathname;
		let params = {
			shareName: document.title,
			clientCallType: "H5",
			shareType: 62,
			shareLink: shareUrl,
			unionRef: this.$route.params.id
		};
		let roomNumber = this.$route.params.roomNumber;
		let shareTitle = "直播来啦！限时特价打到骨折",
			shareContent = this.roomData.title + "-" + this.roomData.theme,
			custShareImageUrl = "",
			posterImageUrl = "",
			typeObj: any = {
				'uxd': '5',
				'ule': '4',
				'usq': '3',
				'uzg': '1'
			};
		let callback = "shareInfo";
		unJsonp(this.api.shareInfo + this.$route.params.id + "?tv_type=" + typeObj[this.source], {
			jsonpcallback: callback,
			jsonp: 'callback',
		}).then((data: any) => {
			if (data) {
				shareTitle = data.main_title || shareTitle;
				shareContent = data.sub_title || shareContent;
				custShareImageUrl = (data.url || "").replace(/http:/, "https:");
				posterImageUrl = this.posterImgUrl.replace(/http:/, "https:") || "";
			}
		}).catch((err) => {
			console.log(err);
		}).then(() => {
			let shareImageUrl = custShareImageUrl || "https:" + this.roomData.portrait.replace(/^http(s)?:/, "");
			let shareObj: any = {
				shareTitle: shareTitle,
				shareContent: shareContent,
				shareImageUrl: shareImageUrl,
				shareUrl: shareUrl,
				shareUrl3: shareUrl
			};
			if (posterImageUrl) {
				shareObj.posterImageUrl = posterImageUrl
				shareObj.shareOptions = "0##1##7"
				shareObj.posterTips = "扫码进入直播间"
			} else {
				shareObj.shareOptions = "0##1"
			}
			// 补充分享埋点所需内容
			shareObj.share_content_type = '直播间'
			shareObj.share_content_name = this.roomData.title
			shareObj.share_content_id = this.roomData.id
			//
			let shareApp = ''
			if (this.browser.ule) {
				shareApp = 'ule';
				shareObj.shareOptions = "0##1"
			} else if (this.browser.ylxd) {
				shareApp = 'ylxd'
			} else if (this.browser.ylxdsq) {
				shareApp = 'ylxdsq'
			}
			(<any>window).uleStatUtil.sendEvent('broadcastShare', shareApp, location.href);
			if (this.browser.ylxd || this.browser.ylxdsq || this.browser.yzgxd) {//邮乐小店   邮乐生鲜   掌柜小店
				this.$http.jsonp("//api" + this.domain + "/ylxditem/item/getShareURL.do", { params: params, jsonp: "jsoncallback" }).then((data: any) => {
					// let linkule = shareUrl + "?storeid=" + this.useronlyid + "&shareId=" + (data.body.data.shareId || "");
					let linkule = data.body.data.shareUrl3;
					shareObj.shareUrl = shareObj.shareUrl3 = linkule;
					(window as any).dsBridge.call("generalAction", {
						type: "2",
						ios_action: JSON.stringify(shareObj),
						android_action: JSON.stringify(shareObj),
					});
				});
			} else {
				(window as any).dsBridge.call("generalAction", {
					type: "2",
					ios_action: JSON.stringify(shareObj),
					android_action: JSON.stringify(shareObj),
				});
			}
		});
	}

	keydown(e: any) {
		//点击键盘发送
		if (e.keyCode == "13") {
			this.sendBarrage();
			this.blur();
		}
	}

	isFirst = false;
	reshtime = 5;
	getLike() {
		let callback = "like";
		let url = `${this.api.getLike}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback + '?t=' + new Date().getTime();

		this.$store
			.dispatch("timing/getLikeAsync", {
				url: url,
				callback: callback,
			})
			.then((res: any) => {
				let num = 0;
				if (!this.isFirst && res.likes == 0) {
					num = 10;
				} else if (!this.isFirst && res.likes != 0) {
					num = res.likes - 0;
				} else {
					num = res.likes - this.likeNum;
				}

				this.reshtime = Math.floor((num * 300) / 1000) > 5 ? Math.floor((num * 300) / 1000) : 5;

				this.isFirst = true;
				let inter = setInterval(() => {
					num--;
					this.bubbling();
					if (num <= 0) {
						clearInterval(inter);
					}
				}, 300);
			});
	}
	cardListIndex: number = 0;
	getCardList() {//获取集卡活动列表
		if (!_intercept()) {
			return false;
		}
		let callback = "card";
		let url = `${this.api.getCardActList}/${this.$route.params.roomNumber}/${Math.floor(new Date().getTime() / 5000)}/` + callback;
		jsonp(url,{
			jsonpcallback: callback
		}).then((res:any) => {
			let cardActIndex = 0;
			res.forEach((card:any,index:number) => {
				if (this.cardAct.curCardActivity && card.cardActivityNo == this.cardAct.curCardActivity.cardActivityNo) {
					cardActIndex = index;
					if (!this.cardAllData[card.cardActivityNo]) {
						this.$store.dispatch("refresh/getUserCardAsync", {
							cardActivityNo: card.cardActivityNo
						}).then(()=>{
							setTimeout(() => {
								this.$forceUpdate()
							}, 500);
						})						
					}
				}
			});
			this.$store.dispatch("refresh/setCardListDataAsync",{
				cardList: res,
				cardActIndex: cardActIndex
			})
			this.$store.dispatch('refresh/setIsCardShowAsync', true);
		});
	}
	getLuckCardList() { //打开福卡列表
		if (!_intercept()) {
			return false;
		}
		this.$store.dispatch('refresh/setLuckCardAllDataAsync',{key:'showListPop',value:true});
	}
	isClick = true;
    getCard(card:any) {
		if (this.isClick) {
			this.isClick = false;
			setTimeout(() => {
				this.isClick = true;
			}, 5000);
		} else {
			return false;
		}
        this.$store.dispatch("refresh/getCardAsync", {
            actNo: card.cardNo,
			cardActivityNo: card.cardActivityNo,
            sceneId: this.roomData.scene_id
        }).then(()=>{
            card.totalNums += 1
			this.$toast('领取成功')
			this.isShowCardTop = false
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)
        },(err)=>{
            this.$toast(err.msg)
        })		        
    }	
    conflateCard(card:any){
		if (this.isClick) {
			this.isClick = false;
			setTimeout(() => {
				this.isClick = true;
			}, 5000);
		} else {
			return false;
		}	
		let channel = '300000'	
		if (this.browser.ylxdsq) {
			channel = '610003'	
		} else if (this.browser.usqxcx) {
			channel = '610002'	
		} else if (this.browser.ylxd) {
			channel = '600000'
		} else if (this.browser.yzgxd) {
			channel = '400006'
		} else if (this.browser.ule) {
			channel = '200000'
		}
        this.$store.dispatch("refresh/conflateCardAsync", {
            cardActivityNo: card.actNo,
            ruleCode: card.combineChances[0].ruleCode,
			conflate:true,
            channel:channel
        }).then(()=>{
			this.$toast('卡片合成成功')
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)
        },(err)=>{	
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)   			
			this.$toast(err.message)
		})
    }
	bubbling() {
		Promise.all(this.assets).then((images: any) => {
			var random = {
				uniform: function (min: number, max: number) {
					return min + (max - min) * Math.random();
				},
				uniformDiscrete: function (i: number, j: number) {
					return i + Math.floor((j - i + 1) * random.uniform(0, 1));
				},
			};
			this.stage.bubble(images[random.uniformDiscrete(0, images.length - 1)]);
		});
	}

	timeOut: any;
	postLikeNum = 0;
	timer1: any;
	reward() {
		if (!_intercept()) {
			return false;
		}
		//点赞事件触发
		this.$store.dispatch("timing/setIsRewardClickAsync", true);
		clearTimeout(this.timer1);
		this.timer1 = setTimeout(() => {
			this.$store.dispatch("timing/setIsRewardClickAsync", false);
		}, 1000)
		this.bubbling();
		this.postLikeNum++;
		clearTimeout(this.timeOut);
		this.$store.dispatch("timing/setLikeAsync", this.likeNum + 1);
		this.timeOut = setTimeout(() => {
			this.fetch({
				url: this.api.submitLike,
				data: {
					room_name: this.$route.params.roomNumber,
					likes: this.postLikeNum,
				},
			}).then((data: any) => {
				if (data.likes > this.likeNum) this.$store.dispatch("timing/setLikeAsync", data.likes);
				this.postLikeNum = 0;
			});
		}, 500);

		let liveName = ''
		if (this.roomData.tvStatus == 0) liveName = '待开播'
		if (this.roomData.tvStatus == 1 && this.roomData.scene_type == '2') liveName = '回放'
		if (this.roomData.tvStatus == 2) liveName = '已结束'

		let ylw_LikeClick = {
			// ylw_live_id: this.roomData.id,
			// ylw_live_name: this.roomData.title,
			// ylw_live_type: liveName,
			ylw_enter_source: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid'),
			ylw_live_id: this.roomData.id,
			ylw_live_name: this.roomData.title,
			ylw_live_type: liveName,
			roomNumber: this.roomData.roomNumber,
			scene_number: this.roomData.scene_number,
			theme: this.roomData.theme,
			ylw_adid: new URLSearchParams(location.search).get('adid') == null ? '' : new URLSearchParams(location.search).get('adid')
		}
		_com.sendSensorTrack('LikeClick', this.roomData, ylw_LikeClick, false, 'yshPoint')
		// _com.sendSensorTrack('点赞', {}, ylw_LikeClick, false, 'yshPoint')

		// 点赞埋点
		// _com.sendSensorTrack('LikeClick', ylw_LikeClick, {})
	}

	goActivity() {
		if (!_intercept()) {
			return false;
		}
		this.$store.dispatch("environment/getIsShowConponAsync", true);
	}

	destroyed() {
		clearInterval(this.timeInter);
		clearInterval(this.timeInterMsg);
	}
}
